import React from 'react';
import './CardRow.css'; // Include a CSS file for styling if needed
import { Navbar, NavDropdown } from 'react-bootstrap';
// import sage from "../../../images/splash/sage.jpeg";
import sage from './sage.png'; // Adjust the path based on your structure
import axios from "axios";
import { var_api } from '../../constant';
import { Card, Form, Button, Table } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

import Nav from 'react-bootstrap/Nav';
import { Link, useHistory } from "react-router-dom";
import { useState, useEffect, useRef } from "react";

function Notification() {
    const [show, setShow] = useState(false);

    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [remainderList, setRemainderList] = useState([]);
    const [valueList, setValueList] = useState([]);
    const [servicePopupShow, setServicePopupShow] = useState(false);
    const [serviceData, setServiceData] = useState([]);
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [value, setValue] = useState('');
    const [addModal, setAddModal] = useState('');

    const handleGoToHome = () => {
        history.push('/sb-home');
    }
    const handelCardRescheduled = () => {
        history.push('/Reschedule-list');
    }
    const handelCardCancellation = () => {
      history.push('/cancelation-appointment-list');
  }
    
    useEffect(() => {
       
        fetchEmployeeDetails();
      }, []);
      const handleClose = () => {
        setAddModal(false);
        resetForm();
    };
    const resetForm = () => {
        setTitle('');
        setDescription('');
        setValue('');
      };
    const changeAmount = async () => {
        try {
          const tokens = localStorage.getItem('token'); // Get the token from local storage
    
          const payload = {
            active_status: 1, // Assuming active_status is always 1
            title,
            description,
            value,
          };
    
          const response = await axios.post(`${var_api}/api/remainder-master/post`,payload,
            {
              headers: {
                Authorization: `${tokens}`, // Set token in the headers
              },
            }
          );
    
          if (response.status === 200) {
            fetchEmployeeDetails(); // Fetch updated data
            handleClose(); // Close the modal
            resetForm();
          }
        } catch (error) {
          console.error('Error changing amount:', error);
          
            console.error(error);
          
        }
      };
    const handleOpen = () => {
        setAddModal(true);
    };
    const handleCloseTable = () => {
        setShow(false);
    };
    
    const handleCloseServicepopup = () => {
        setServicePopupShow(false);
    };
    async function fetchByValue(value) {
        setLoading(true);
        const tokens = localStorage.getItem('TOKEN');
    
        try {
          const response = await axios.get(`${var_api}/api/booking-remainder-bookings/${value}`, {
            headers: {
              'Authorization': `${tokens}`,
            },
          });
          setValueList(response.data);
          setShow(true);
        } catch (error) {
          console.error('Error fetching by value:', error);
         
        } finally {
          setLoading(false);
        }
      };
      async function fetchEmployeeDetails() {
        setLoading(true);
        const tokens = localStorage.getItem('token');
        
        try {
          const response = await axios.get(`${var_api}/api/remainder-master/get`, {
            headers: {
              'Authorization': `${tokens}`,
            },
          });
          setRemainderList(response.data);
        } catch (error) {
      
            console.error('Error fetching users:', error);
          
        } finally {
          setLoading(false);
        }
      };
      const handleCardClick = () => {
        history.push('/new-appointments');
      };
      const servicePopup = (data) => {
        setServicePopupShow(true);
        setServiceData(data);
      };
  return (
    <>
    <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
    <Navbar.Brand href="#home">
        <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
    </Navbar.Brand>
    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
    <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="mx-auto">
            <Nav.Link href="#" style={{ color: "black", fontSize: "25px", letterSpacing: "2px" }}>
                Notification
            </Nav.Link>
        </Nav>
        <Nav className="ms-auto">
            <Nav.Link onClick={handleGoToHome} style={{ color: "black", fontSize: "15px" }}>
                <button className="btn" style={{ backgroundColor: "rgb(89, 128, 71)", color: "white" }}>
                    <i className="bi bi-house"></i> Go to home
                </button>
            </Nav.Link>
        </Nav>
    </Navbar.Collapse>
</Navbar>
<br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <p style={{marginLeft:'60px'}}>Remainders</p>

<div className="card-row">
  {/* First Card */}
  
               {remainderList.length > 0 ? (
                remainderList.map((reminder) => (
  <div className="cards" key={reminder.id}  onClick={() => fetchByValue(reminder.value)}>
    
    {/* <h3 className="card-header">Appointment Updates</h3> */}
    <div className="card-body">
    <h3>{reminder.title}</h3>
    <p>{reminder.description}</p>

    </div>
  </div>
  
    ))
) : (
  <p>No reminders available</p>
)}
<div className="cards" onClick={handleOpen}>
        
        {/* <h3 className="card-header">Appointment Updates</h3> */}
        <div className="card-body">
        <h3><i class="bi bi-plus"></i></h3>
        <p>Create New</p>

        </div>
      </div>


 
</div>
            <p style={{marginLeft:'60px'}}>Appointment Updates</p>

    <div className="card-row">
      {/* First Card */}

      <div className="cards" onClick={handleCardClick}>
        
        {/* <h3 className="card-header">Appointment Updates</h3> */}
        <div className="card-body">
        <h3>New Appointments</h3>
        <p>Full List Today</p>

        </div>
      </div>

      {/* Second Card */}
      <div className="cards" onClick={handelCardRescheduled}>
        <div className="card-body">
        <h3>Reschedule Appointments</h3>
          <p>Last 30 days </p>
        </div>
      </div>

      {/* Third Card */}
      <div className="cards" onClick={handelCardCancellation}>
        <div className="card-body">
        <h3>Cancelled Appointments</h3>
        <p>Last 30 days </p>        </div>
      </div>
    </div>

    <p style={{marginLeft:'60px'}}>Waitlist Updates</p>

<div className="card-row">
  {/* First Card */}

  <div className="cards" onClick={handelCardRescheduled}>
    
    {/* <h3 className="card-header">Appointment Updates</h3> */}
    <div className="card-body">
    <h3>Time Slot Available</h3>
    <p>Full List Today</p>

    </div>
  </div>

</div>
<br/><br/><br/>
<Modal
                        show={show}
                        onHide={handleCloseTable}
                        backdrop="static"
                        keyboard={false}
                        size='fullscreen'
                    >
                        <Modal.Header closeButton>
                            <Modal.Title> Change Referal Point Value</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ overflow: 'scroll' }}>
                            <div>
                                <Card
                                    bg="light"
                                    text="dark"
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        border: "none",
                                        borderBottom: "1px solid black",
                                        borderRadius: "0px",
                                        marginTop: "10px"
                                    }}
                                    className="mb-2"
                                >
                    
               <Table striped="columns" className="scrollable-table" bg="warning"  >
               <thead>
                                            <tr>
                                            <th scope="col">S.No</th>
                    <th scope="col">Token No</th>
                    <th scope="col">Customer Name</th>
                    <th scope="col">Customer Mobile</th>
										<th scope="col">Booking Time</th>	
                    <th scope="col">Booking Date</th>	
										<th scope="col">Slot Time</th>	
										<th scope="col">Total Amount</th>	
										<th scope="col">Customer Name</th>	
										<th scope="col">Services</th>	
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                valueList.map((customer, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>

                                                        <td>{customer.token_no}</td>
                                                        <td>{customer.customer_name}</td>
                                                        <td>{customer.customer_mobile}</td>
                                                            
                                                        <td>{customer.booking_time}</td>
                                                        <td>{customer.booking_date}</td>
                                                        <td>{customer.slot_time}</td>
                                                            
                                                        <td>{customer.total_amount}</td>
                                                        <td>{customer.customer_name}</td>
                                                        <td><Button variant='dark' onClick={() => servicePopup(customer.services)}>{customer.services.length}Services</Button></td>
                                                            
                                                            
                                                            </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>

                                    {/* Pagination Controls using react-js-pagination */}

                                </Card>
                            </div>
                        </Modal.Body>
                    </Modal>

                    <Modal
                        show={servicePopupShow}
                        onHide={handleCloseServicepopup}
                        backdrop="static"
                        keyboard={false}
                        size='m'
                    >
                        <Modal.Header closeButton>
                            <Modal.Title> Services</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ overflow: 'scroll' }}>
                            <div>
                                <Card
                                    bg="light"
                                    text="dark"
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        border: "none",
                                        borderBottom: "1px solid black",
                                        borderRadius: "0px",
                                        marginTop: "10px"
                                    }}
                                    className="mb-2"
                                >
                    
               <Table striped="columns" className="scrollable-table" bg="warning"  >
               <thead>
                                            <tr>
                                            <th scope="col">S.No</th>
                    <th scope="col">Service Name</th>
                    <th scope="col">From Time</th>
                    <th scope="col">To Time</th>
										<th scope="col">Price</th>	
                    <th scope="col">Employee Name</th>	
										<th scope="col">Duration <span><h6>(In mins)</h6></span></th>	
									
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                serviceData.map((service, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>

                                                        <td>{service.service_name}</td>
                                                        <td>{service.from_time}</td>
                                                        <td>{service.to_time}</td>
                                                            
                                                        <td>{service.price}</td>
                                                        <td>{service.emp_name}</td>
                                                        <td>{service.duration}</td>
                                                            
                                                       
                                                            
                                                            </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>

                                    {/* Pagination Controls using react-js-pagination */}

                                </Card>
                            </div>
                        </Modal.Body>
                    </Modal>

                    <Modal show={addModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Change Referal Point Value</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-4">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label>Description</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label>Value</Form.Label>
            <Form.Control
              type="number"
              placeholder="Enter Value"
              value={value}
              onChange={(e) => setValue(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="dark" onClick={changeAmount}>
          Add
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  );
}

export default Notification;
